export default __webpack_public_path__ + "static/media/funnelIcon.6c3b50d6.svg";